<template>
<v-card flat>
  <v-card-text >
    <template v-if='chips' >
      <v-chip-group column v-model="selected" :multiple="multiple" active-class="primary" >
        <template v-for='space in formattedSpaces' >
          <v-chip small
            v-if="returnObject"
            :key='space.id'
            :value='space' >{{space.title}}</v-chip>
          <v-chip small
            v-else
            :key='space.id'
            :value='space.id' >{{space.title}}</v-chip>
        </template>
        <slot name="chips-after" ></slot>
      </v-chip-group>
    </template>

    <template v-else >
      <template v-if='multiple' >
        <v-checkbox dense hide-details
          v-for='space in formattedSpaces'
          v-model='selected'
          :key="space.id"
          :value='space.id'
          :label='getLabel(space)'
          class='pa-0 ma-0' />
      </template>
      <template v-else >
        <v-radio-group
          v-model='selected' >
          <v-radio dense hide-details
            v-for='space in formattedSpaces'
            :key="space.id"
            :value='space.id'
            :label='getLabel(space)'
            class='pa-0 ma-0' />
        </v-radio-group>
      </template>
    </template>
  </v-card-text>
</v-card>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SpacePicker',
  props: {
    value: { },
    title: { type: String, default: 'Choose a space' },
    chips: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false },
    ownerRequired: { type: Boolean, default: false }
  },
  data () {
    return {
      selected: null
    }
  },
  mounted () {
    if (this.multiple) {
      this.selected = []
    } else {
      this.selected = null
    }
    if (this.value) {
      this.selected = this.value
    }
  },
  watch: {
    value () {
      if (this.value) {
        // if (this.multiple) { this.selected = [this.value] }
        // else { this.selected = this.value }
        this.selected = this.value
      }
    },
    numSpaces () {
      this.$emit("spaces", this.spacesList)
    },
    selected () {
      if (this.selected) {
        this.$emit('input', this.selected)
      }
    }
  },
  methods: {
    getLabel (space) {
      if (space.archived) {
        return space.title + ' (archived)'
      }
      return space.title
    }
  },
  computed: {
    ...mapGetters('identity', [
      'spacesList'
    ]),
    numSpaces () {
      if (this.formattedSpaces) {
        return this.formattedSpaces.length
      }
      return 0
    },
    formattedSpaces () {
      if (this.ownerRequired) {
        return this.spacesList.filter((space) => { return space.role === 'Owner' })
      }
      return this.spacesList
    }
  }
}
</script>
